import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";

export const DRIVE_KEYS_PAGE_SIZE = 100;
/**
 * Query drive keys
 */
export default async function getDriveKeys(query: { entry_ids: string[] }) {
  const res = await fetchOrchidAPI("/api/drive/keys/", {
    credentials: "include",
    mode: "cors",
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(query),
  });

  if (!res.ok) {
    throw new Error(
      `failed to get file encryption keys: ${getErrorDetail(await res.text())}`,
    );
  }

  const data: {
    key_entries: {
      entry_id: string;
      data_cipher_key: string;
      meta_data_cipher_key: string;
      checksum_sha256: string;
    }[];
    failed_entries: {
      entry_id: string;
      error: string;
    }[];
  } = await res.json();

  if (data.failed_entries.length > 0) {
    console.error(
      "Failed to retrieve some of the drive keys: ",
      data.failed_entries,
    );
    throw new Error("failed to retrieve some of the drive keys");
  }

  return data;
}
